module.exports = __webpack_public_path__ + "img/pennsylvania_election.1ae5e35e.png";